export enum NfpaUrlPaths {
    MyProfile = "User/My-Account/Account-Information",
    TermsOfUse = "termsofuse",
}
